import ReactPixel from 'react-facebook-pixel';
import './styles/HeroSection.css';


function HeroSection() {

    const handleClickFirstBtn = () => {
        ReactPixel.track('InitiateCheckout', {
          action: 'Clique CTA QUERO GARANTIR MINHA VAGA',
          origem: 'Seção Hero',
        });
        ReactPixel.track('Lead', {
          action: 'Clique CTA QUERO GARANTIR MINHA VAGA',
          origem: 'Seção Hero',
        });
        window.open('https://pay.hotmart.com/K104003704P?off=0tb745dd&checkoutMode=10', '_blank');
      };

   return (
        <div className="Hero">
            <div className="HeroTexts">
                <h1>ZONA LIVRE DE QUEDA E FATOR DE QUEDA</h1>
                <h2>Domine os cálculos que <strong>salvam vidas</strong> nos trabalhos em altura!</h2>
                <p>Curso técnico e prático sobre segurança em alturas, conforme <strong>NR-35</strong> e <strong>ABNT NBR 16489, NBR 15834 e NBR 14628.</strong></p>
                <button id='hero-btn' onClick={handleClickFirstBtn} aria-label="Clique para garantir sua vaga no curso">QUERO GARANTIR MINHA VAGA</button>
            </div>
        </div>
   )
};

export default HeroSection;